

export const getObjectNamesByIdSelector = (state) => {
    if (!state.objects.objects) {
        return
    }
    return Object.values(state.objects.objects).reduce((acc, cur) => {
        return {...acc, [cur.id]: cur.name}
    }, {})
}